import { render, staticRenderFns } from "./SubFormAfcXhosp.vue?vue&type=template&id=6511ba76&"
import script from "./SubFormAfcXhosp.vue?vue&type=script&lang=js&"
export * from "./SubFormAfcXhosp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports